export default "__VITE_ASSET__DpSJtabr__"